import { render, staticRenderFns } from "./DataTableMain.vue?vue&type=template&id=7475b7bc"
import script from "./DataTableMain.vue?vue&type=script&lang=js"
export * from "./DataTableMain.vue?vue&type=script&lang=js"
import style0 from "./DataTableMain.vue?vue&type=style&index=0&id=7475b7bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports